import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDeparturePlanChangesData from './DriverJobsSiteDeparturePlanChanges';

interface DriverJobsSiteDepartureCompleteProps {
    completeJob: PlanChanges;
    isPickup: boolean;  //true if all jobs are pickups
    back(): void;
    update(completeJob: PlanChanges): void;
    next(): void;
}

interface DriverJobsSiteDepartureComplete {
    loading: boolean;
    errors: any;
}

interface PlanChanges {
    planChanges: number;
    plan: File,
    planComments: string;
    notes: string;
}

export default class DriverJobsSiteDepartureCompleteData extends React.Component<DriverJobsSiteDepartureCompleteProps, DriverJobsSiteDepartureComplete> {
    constructor(props: DriverJobsSiteDepartureCompleteProps) {
        super(props);

        this.state = {
            loading: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    updatePlanChanges = (planChanges: PlanChanges, fieldName: string) => {
        var errors = this.state.errors;
        if (fieldName) {
            delete errors[fieldName];
        }
        this.props.update(planChanges);
    }

    validate = () => {
        let jobItems = this.props.completeJob;
        let errors: any = {};
        let formIsValid = true;

        var planChanges = jobItems.planChanges * 1;
        if (planChanges < 0) {
            formIsValid = false;
            errors["planChanges"] = "Plan Changes is required";
        } else if (planChanges === 1) {
            if (jobItems.plan.size === 0) {
                formIsValid = false;
                errors["plan"] = "You must upload a photo of the plan changes";
            }
            if (!jobItems.planComments) {
                formIsValid = false;
                errors["planComments"] = "Plan Comments are required";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    next = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.props.next();
        } else {
            toast.error("Please check validation errors before going Next!");
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let completeJob = this.props.completeJob;
        let planChangesQuestions = <DriverJobsSiteDeparturePlanChangesData planChanges={completeJob} isPickup={this.props.isPickup} errors={this.state.errors} update={this.updatePlanChanges} />

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Job Complete</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>
                    {planChangesQuestions}
                    <div className="defaultbutton__container--right marginTop10">
                        <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => this.next(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
